module.exports = __webpack_public_path__ + "static/img/showtemp.8805d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showtemp.png
// module id = 7cZ/
// module chunks = 1